import { useSignOutMyBrightlink } from '@xolv-mybrightlink/mybrightlink';
import {
  ConfirmationDialog,
  useAnalytics,
  METRICS_SIGN_OUT,
} from '@xolv-mybrightlink/common';
import { useClearAuth } from '@xolv-mybrightlink/security';

interface SignOutDialogProps {
  open: boolean;
  setOpen: (value: boolean) => void;
}
export const SignOutDialog = (props: SignOutDialogProps) => {
  const clearAuth = useClearAuth();
  const signOutMyBrightlink = useSignOutMyBrightlink();
  const analytics = useAnalytics();

  const handleProcessSignOut = async () => {
    props.setOpen(false);
    analytics.trackAction(METRICS_SIGN_OUT);
    clearAuth();
    await signOutMyBrightlink();
  };
  const handleCancelSignOut = () => {
    props.setOpen(false);
  };

  return (
    <ConfirmationDialog
      open={props.open}
      titleId='sidebar.sign-out'
      contentId='sidebar.sign-out.body'
      primaryActionTitleId='sidebar.sign-out'
      primaryAction={handleProcessSignOut}
      secondaryActionTitleId='common.cancel'
      secondaryAction={handleCancelSignOut}
    />
  );
};
